import { getMomentDate } from '../utils/commonUtils';
import { PAGINATION } from '../constants/Define';
import moment from 'moment';
export default class SaleReportByOrder {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(data = {}) {
        this.totalRevenue = data.totalRevenue || 0;
        this.totalOrder = data.totalOrder || 0;
        this.voucherOrders = data.voucherOrders || 0;
        this.tourOrders = data.tourOrders || 0;
        this.flightOrders = data.flightOrders || 0;
        this.hotelOrders = data.hotelOrders || 0;
        this.vinWonderOrders = data.vinWonderOrders || 0;
        this.setSaleReportByOrderItems(data.saleReportItems || {});
    }

    setSaleReportByOrderItems(data={}){
        this.saleReportByOrderItems = {
            pageIndex: data.pageIndex || PAGINATION.pageIndex,
            pageSize: data.pageSize || PAGINATION.pageSize,
            totalCount: data.totalCount || 0,
            totalPage: Math.ceil(parseInt(data.totalCount || 0) / parseInt(data.pageSize || PAGINATION.pageSize)),
            startDate: data.startDate ? moment.utc(data.startDate) : moment.utc().startOf('isoWeeks'),
            endDate: data.startDate ? moment.utc(data.endDate) : moment.utc().endOf('days'),
            orderBy: data.orderBy,
            orderByDesc: data.orderByDesc,
            items: data.result && data.result.map(item => new SaleReportByOrderItem(item))
        }
    }

}

export class SaleReportByOrderItem {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(data = {}) {
        this.id = data.id || undefined;
        this.createdDate = getMomentDate(data.createdDate);
        this.couponCode = data.couponCode || undefined;
        this.couponValue = data.couponValue || undefined;
        this.currencyCode = data.currencyCode || undefined;
        this.email = data.email || undefined;
        this.emailHistories = data.emailHistories || undefined;
        this.firstname = data.firstname || undefined;
        this.invoice = data.invoice || undefined;
        this.itemTypes = data.itemTypes || undefined;
        this.languageCode = data.languageCode || undefined;
        this.lastname = data.lastname || undefined
        this.note = data.note || undefined;
        this.orderCode = data.orderCode || undefined;
        this.paymentType = data.paymentType || undefined;
        this.phoneNumber = data.phoneNumber || undefined;
        this.saleChannel = data.saleChannel || undefined;
        this.status = data.status || undefined;
        this.paymentStatus =  data.paymentStatus || 0;
        this.subTotal = data.subTotal || 0;
        this.totalAmount = data.totalAmount || 0;
        this.totalSurcharge = data.totalSurcharge || 0;
        this.totalChangeRateCode = data.totalChangeRateCode || 0;
        this.transactionId = data.transactionId || undefined;
        this.channel = data.channel || undefined;
    }
}